import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("span", {
    class: _normalizeClass(_ctx.isActive ? 'active' : 'disabled'),
    onClick: _cache[0] || (_cache[0] = //@ts-ignore
    function () {
      return _ctx.onClickBtn && _ctx.onClickBtn.apply(_ctx, arguments);
    })
  }, _toDisplayString(_ctx.btnText), 3);
}